/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import {
    DrmType,
    SessionManagerType,
    TransportEncodingType,
    VideoProviderConfiguration,
} from 'client-code/video-provider-configurations';

import { VPConfigurationsServiceRepositoryImpl } from '../impls/VPConfigurationsServiceRepositoryImpl';
import { IVPConfigurationsServiceRepository } from '../interfaces/IVPConfigurationsServiceRepository';
import { Storage } from '../storage';
import { TServicesParams } from '../types/TServicesParams';

export class VPConfigurationsService implements IVPConfigurationsServiceRepository {
    private oVPConfigurationsServiceRepository: VPConfigurationsServiceRepositoryImpl;

    public constructor(params: TServicesParams) {
        this.oVPConfigurationsServiceRepository = new VPConfigurationsServiceRepositoryImpl(params);
    }

    public fetchVPConfigurationsForVideoPlayer(
        linearProviderPartnerId: string,
        forceNetworkCall?: boolean,
    ): Promise<Array<VideoProviderConfiguration>> {
        return this.oVPConfigurationsServiceRepository.fetchVPConfigurationsForVideoPlayer(
            linearProviderPartnerId,
            forceNetworkCall,
        );
    }

    public async fetchVPConfigurations(
        supportedDrmType: Array<DrmType>,
        supportedTransportEncodingType: Array<TransportEncodingType>,
    ): Promise<void> {
        return this.oVPConfigurationsServiceRepository.fetchVPConfigurations(
            supportedDrmType,
            supportedTransportEncodingType,
        );
    }

    // eslint-disable-next-line class-methods-use-this
    public getDeviceRegistrationServiceUrlForCubiware(): string {
        const vpConfigurationsData: VideoProviderConfiguration[] = Storage.getInstance().getItem(
            Storage.Keys.VIDEO_PROVIDER_CONFIGURATIONS_DATA,
        );

        if (!vpConfigurationsData) {
            throw new Error('VP Configurations data not found in storage');
        }

        const cubiwareConfig = vpConfigurationsData.find(
            (config) =>
                config.sessionManagerConfig?.sessionManagerType === SessionManagerType.Cubiware ||
                config.sessionManagerConfig?.sessionManagerType === SessionManagerType.TivoCubiware,
        );

        if (!cubiwareConfig) {
            throw new Error('Cubiware config not found');
        }

        const cubiwareUrl = cubiwareConfig.drmConfig?.deviceRegistrationServiceUrl;
        if (!cubiwareUrl) {
            throw new Error('Cubiware URL not found in config');
        }

        return cubiwareUrl;
    }
}
